import { MultiJumpInfo } from '@tencent/wphk-components-multi-jump-container';

/** 跳转类型 */
enum JumpType {
  H5 = 0,
  MP = 1,
}
/** 热门商户投放数据 */
export type MerchantDpList = {
  /** 标题 */
  title: string;
  /** 描述 */
  desc: string;
  /** logo */
  logo: string;
  /** 详情 logo */
  detailLogo: string;
  /** 主题对应的投放位置 */
  contentPosition: string;
  /** 主题对应的商户列表 */
  merchantList: MerchantItem[];
  /** 是否在首页展示 */
  isHomeShow?: boolean;
};

// 自定义弹窗类型
export enum CustomEventKey {
  /** 地铁 */
  'subway' = 'subway',
  /** 所有推荐列表 */
  'all' = 'all',
}

/** 热门商户 */
export type MerchantItem = {
  /** 标题 */
  title: string;
  /** 描述 */
  desc: string;
  /** logo */
  logo: string;
  /** 跳转类型 */
  jumpType: JumpType;
  /** 自定义事件key */
  customEventKey: CustomEventKey;
} & MultiJumpInfo;
